import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { traceRouting } from '../../utils/routingDebug';

/**
 * Listens for `auth:account-inactive` events dispatched by apiClient when a 403
 * ACCOUNT_SUSPENDED / ACCOUNT_BLOCKED is received (#559), and SPA-navigates to
 * /account/inactive.
 *
 * Mounted once in App.jsx at the root, next to <TermsRedirectListener />.
 * Renders nothing.
 *
 * Same doctrine as the terms listener: apiClient dispatches instead of doing a
 * hard `window.location.href`, which used to interrupt in-flight fetches and
 * flash a Suspense fallback.
 */
const AccountStatusListener = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handler = (event) => {
      if (location.pathname === '/account/inactive') return; // already there
      traceRouting('AccountStatusListener', 'Navigate', {
        to: '/account/inactive',
        reason: event?.detail?.code || '403_ACCOUNT_INACTIVE',
        endpoint: event?.detail?.endpoint,
      });
      navigate('/account/inactive', { replace: true });
    };

    window.addEventListener('auth:account-inactive', handler);
    return () => window.removeEventListener('auth:account-inactive', handler);
  }, [navigate, location.pathname]);

  return null;
};

export default AccountStatusListener;
